import { Promotion } from "../models/giveaway";

function KeyFeaturesAndSpecifications({ promotion }: { promotion: Promotion }) {
	const randomImageNumber = Math.floor(
		Math.random() * promotion.prize.images.length
	);
	const baseURL = import.meta.env.VITE_SERVER_API_URL;
	const prizeImage = `${baseURL}/common/image/${promotion.prize.images[randomImageNumber]?.url}`;

	const titleStyle = {
		background:
			"linear-gradient(161deg, #0FF1E5 3.9%, #0DAAEC 33.24%, #0823F8 72.3%, #000D74 116.02%)",
		WebkitBackgroundClip: "text",
		backgroundClip: "text",
		WebkitTextFillColor: "transparent",
	};

	return (
		<div className="max-sm:bg-blue flex flex-col gap-8 px-4 py-16 md:flex-row md:gap-16 md:px-37 md:py-50">
			<img
				src={prizeImage}
				className="h-70 w-full rounded-[32px] object-cover md:h-150 md:w-181"
			/>
			<div className="flex flex-col gap-8">
				<span className="web-heading-h2">
					<span style={titleStyle}>Key Features</span> & Specifications
				</span>

				<div
					className="[&_hr]:hidden"
					dangerouslySetInnerHTML={{ __html: promotion.prize.specifications }}
				></div>
			</div>
		</div>
	);
}

export default KeyFeaturesAndSpecifications;
